module.exports = __webpack_public_path__ + "static/media/panis_6.395fbc09.jpg";